<section class="popup-page">
  <header>
    <button type="button" class="icon-button" (click)="back()" [attr.aria-label]="'PROFILE_POPUP_BACK' | translate">&#8249;</button>
    <div class="title">
      <span class="user-name">{{ userName }}</span>
      <h2>{{ 'PROFILE_POPUP_ADD_ACCESS' | translate }}</h2>
    </div>
    <button type="button" class="icon-button" (click)="close()" [attr.aria-label]="'CLOSE' | translate">&#215;</button>
  </header>
  <h3>{{ 'ASSIGN_ACCESS' | translate }}</h3>
  <p class="subtitle">{{ building?.buildingName }}</p>
  <div class="building-list" [attr.aria-label]="building?.buildingName">
    <p *ngIf="!units.length" class="empty" role="status">{{ 'NO_UNIT_IN_THIS_BUILDING' | translate }}</p>
    <button *ngFor="let unit of units" type="button" class="building" (click)="selectUnit(unit)">
      <span class="building-icon" aria-hidden="true">
        <img src="assets/svg/ico-default-home.svg" alt="" />
      </span>
      <span class="building-name" [title]="unit.label">{{ unit.label }}</span>
      <img class="chevron" src="assets/svg/ico-chevron-forward-outline.svg" alt="" aria-hidden="true" />
    </button>
  </div>
</section>